var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.992a.968.968 0 0 0-.713.288.964.964 0 0 0-.287.712v4c0 .283.096.521.288.713.192.192.43.288.712.287a.968.968 0 0 0 .713-.288.964.964 0 0 0 .287-.712v-4a.968.968 0 0 0-.288-.713.964.964 0 0 0-.712-.287zm0 8a.968.968 0 0 0-.713.288.964.964 0 0 0-.287.712c0 .284.096.521.288.713.192.192.43.288.712.287a.968.968 0 0 0 .713-.288.964.964 0 0 0 .287-.712.968.968 0 0 0-.288-.713.964.964 0 0 0-.712-.287zm0-13c1.383 0 2.683.263 3.9.788a10.114 10.114 0 0 1 3.175 2.137c.9.9 1.612 1.959 2.137 3.175a9.755 9.755 0 0 1 .788 3.9 9.733 9.733 0 0 1-.788 3.9 10.114 10.114 0 0 1-2.137 3.175c-.9.9-1.958 1.613-3.175 2.137a9.755 9.755 0 0 1-3.9.788 9.733 9.733 0 0 1-3.9-.788 10.114 10.114 0 0 1-3.175-2.137c-.9-.9-1.613-1.958-2.138-3.175a9.72 9.72 0 0 1-.787-3.9c0-1.383.263-2.683.788-3.9a10.114 10.114 0 0 1 2.137-3.175c.9-.9 1.958-1.612 3.175-2.138a9.72 9.72 0 0 1 3.9-.787zm0 2c-2.233 0-4.125.775-5.675 2.325C4.775 7.867 4 9.76 4 11.992c0 2.233.775 4.125 2.325 5.675 1.55 1.55 3.442 2.325 5.675 2.325 2.233 0 4.125-.775 5.675-2.325 1.55-1.55 2.325-3.442 2.325-5.675 0-2.233-.775-4.125-2.325-5.675-1.55-1.55-3.442-2.325-5.675-2.325z",
    fill: "#E01D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.26482cb9224085990c604c8baef4e6b6.svg";
export { ForwardRef as ReactComponent };